import { OrganizationCalendarI } from "@interfaces/organizationI"
import { RootState } from "@redux/store"
import { getPractitionerOrganizationM2 } from "@services/services/servies"
import { useCallback, useEffect, useState } from "react"
import { useSelector } from "react-redux"

const usePractitionerOrganizations = (omitFirtsLoad?:boolean) => {
    const [ organizations, setOrganizations ] = useState<OrganizationCalendarI[] | null>(null)
    const [ error, setError ] = useState<unknown | null>(null)
    const [ isLoading, setIsLoading ] = useState<boolean>(false)
    const [ hasLoaded, setHasLoaded ] = useState<boolean>(false)
    const { username } = useSelector((state: RootState) => state.session)

    const loadOrganizations = useCallback(async() => {
        let orgnizationRes: OrganizationCalendarI[] = []
        if(!username) return
        setHasLoaded(false)
        try
        {
            setIsLoading(true)
            const resp = await getPractitionerOrganizationM2(username)
            orgnizationRes = resp
            setOrganizations(resp)
            setError(null)
        }
        catch(err)
        {
            orgnizationRes = []
            console.error("getPractitionerOrganizationM", err)
            setError(err)
        }
        finally
        {
            setIsLoading(false)
            setHasLoaded(true)
        }
        return orgnizationRes
    }, [username])

    useEffect(() => {
        console.debug("Something happened")
        if(!omitFirtsLoad){
            loadOrganizations()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadOrganizations])

    return { organizations, error, isLoading, loadOrganizations, hasLoaded }
}

export default usePractitionerOrganizations
